import React, {Component} from 'react';
import { Button } from 'reactstrap';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import Config from '../../config';

const ResponsiveGridLayout = WidthProvider(Responsive);


class FastButtons extends Component {
 constructor(props) {
  super(props);

  this.state = {
   editable: false,
   layouts: []
  };
 }

 onLayoutChange(layouts) {
  // TO SAVE
 }

 getItem(id) {
  this.props.reqAPI(Config.apiURI+'/api/products/'+id).then(product => {
   this.props.addToCart(product);
  }, err => {
   console.log(err);
  })
 }
 
 render() {
  var layout = [
   {i: '712',  x: 2,  y: 0, w: 2, h: 1, minW: 1, maxW: 3, maxH: 1, maxY: 1, title: 'Fotocopia DNI'},
   {i: '686',  x: 2,  y: 1, w: 2, h: 1, minW: 1, maxW: 3, maxH: 1, maxY: 1, title: 'Estudiante B/N'},
   {i: '4',  x: 5,  y: 0, w: 1, h: 1, minW: 1, maxW: 3, maxH: 1, maxY: 1, title: 'A3'},
   {i: '3',  x: 6, y: 0, w: 2, h: 1, minW: 1, maxW: 3, maxH: 1, maxY: 1, title: 'Fotocopia Color'},
   {i: '307',  x: 8, y: 0, w: 2, h: 1, minW: 1, maxW: 3, maxH: 1, maxY: 1, title: 'Imp. foto Color'},
   {i: '308',  x: 10, y: 0, w: 1, h: 1, minW: 1, maxW: 3, maxH: 1, maxY: 1, title: 'A3'},
   {i: '2',  x: 5,  y: 1, w: 1, h: 1, minW: 1, maxW: 3, maxH: 1, maxY: 1, title: 'A3'},
   {i: '1',  x: 6, y: 1, w: 2, h: 1, minW: 1, maxW: 3, maxH: 1, maxY: 1, title: 'Fotocopia B/N'},
   {i: '309',  x: 8, y: 1, w: 2, h: 1, minW: 1, maxW: 3, maxH: 1, maxY: 1, title: 'Imp. foto B/N'},
   {i: '310', x: 10, y: 1, w: 1, h: 1, minW: 1, maxW: 3, maxH: 1, maxY: 1, title: 'A3'},
  ];

  const layouts = { lg: layout, md: layout, sm: layout, xs: layout, xxs: layout };

  return (
   <div>
    <ResponsiveGridLayout className="layout" className="layout" layouts={layouts} isDraggable={this.state.editable} isResizable={this.state.editable} onLayoutChange={this.onLayoutChange} cols={{lg: 14, md: 14, sm: 14, xs: 12, xxs: 6}} rows={2} rowHeight={30}>
     {layout.map((button, i) => (
      <Button key={button.i} outline color="secondary" onClick={() => {this.getItem(button.i)}} className="btn-sm" style={{"color":"rgb(34, 34, 34)", "backgroundColor":"rgb(200,200,200)"}}>{button.title}</Button>
     ))}
    </ResponsiveGridLayout>
    <div className="card-actions">
     <i className="fa fa-gear" style={{paddingRight: '5px', cursor: 'pointer'}} onClick={() => {
      this.setState({editable: !this.state.editable});
     }} title="Mueve de posición los botones de acceso rapido"></i>
    </div>
   </div>
  )
 }
}

export default FastButtons;


// WEBPACK FOOTER //
// ./src/views/ShoppingCart/FastButtons.js